const getVideoSourceData = (landscapeSource, portraitSource) => {
  if (landscapeSource && portraitSource) {
    return {
      mobileVideo: { data: portraitSource, orientation: 'portrait' },
      desktopVideo: { data: landscapeSource, orientation: 'landscape' },
    };
  }

  const fallback = landscapeSource || portraitSource;
  const orientation = landscapeSource ? 'landscape' : 'portrait';

  return {
    mobileVideo: { data: fallback, orientation },
    desktopVideo: { data: fallback, orientation },
  };
};

export default {
  getVideoSourceData,
};
